import { gql } from "@apollo/client";

export const MESSAGE_SENT_SUBSCRIPTION = gql`
  subscription ConversationMessageSent($userId: String!) {
    conversationMessageSent(userId: $userId) {
      id
      text
      audioUrl
      fileUrls
      createdAt
      conversation {
        id
      }
      sender {
        id
        name
        lastname
        profileImage
      }
    }
  }
`;

export const USER_TYPING_SUBSCRIPTION = gql`
  subscription UserTyping($conversationId: String!, $userId: String!) {
    userTyping(conversationId: $conversationId, userId: $userId) {
      conversationId
      user {
        id
        name
        lastname
        profileImage
      }
      isTyping
    }
  }
`;
